import { IAction, IActionDAO } from './action';
import { IBaseEntity } from './base';
import { ICourseNode } from './course';
import { IGroup } from './group';
import { IImageDAO } from './image';
import { ISceneDAO } from './scene';
import { ISessionAttempt } from './session';
import { IText, ITextDAO } from './text';
import { IVariableDAO } from './variable';

export interface IModule extends IBaseEntity {
  name: string;
  moduleConfigId: number;
  textId: number;
  imageId: number;
  originalId: number;
  variableId: number;
  forumId: number;
  folderId: number;
  parentFolderId: number;
  actionId: number;
  uploadId?: string;
  type: ModuleType;
  status: ModuleStatus;
  url: string;
  __stage: number;
  __stale: boolean;
  actions: IAction[];
  stage: ModuleStage;
  assess?: any;
  public: boolean;
}

export interface IModuleConfig extends IBaseEntity {
  moduleId: number;
  moduleInstanceId: number;
  languageId: number;
  maxValue: number;
  minValue: number;
  scormVersion: string;
}

export interface IModuleDAO extends IModule {
  text: IText;
  image: IImageDAO;
  outs: IModuleOut[];
  actions: IAction[];
  scenes: ISceneDAO[];
  variable: IVariableDAO;
  clonedVersion?: IModuleVersion;
  versions?: IModuleVersion[];
  //tags: ITagJoin[];
  courseNode?: ICourseNode;
  courseName?: string;
}

export interface IModuleFlowNode {
  id: string;
  depth: number;
  data: any;
  children: IModuleFlowNode[];
  index: number;
  source: string;
  sourceHandle: string;
  height: number;
  position: { x: number; y: number };
}

export interface IModuleDetailDAO extends IModuleDAO {
  outs: IModuleOut[];
  actions: IActionDAO[];
  courseNodes: ICourseNode[];
}

export interface IModuleBasicDAO extends IModule {
  sessionAttemptId?: number;
  name: string;
  text: ITextDAO;
  image: IImageDAO;
  type: ModuleType;
  status: ModuleStatus;
  //tags: ITagJoinDAO[];
}

export interface IModuleAssign extends IModuleBasicDAO {
  modifiedDate: string;
  canContinue: boolean;
  sessionAttempt: ISessionAttempt;
  startActionId: number;
  sessionAttemptId: number;
  suspendData: string;
}

export enum ModuleType {
  STANDARD = 0,
  PPT = 1,
  PDF = 2,
  TEXT = 3,
  YOUTUBE = 4,
  WEBSITE = 5,
  SCORM = 6,
  VR = 7,
  AR = 8,
  MAIL = 9,
}

export enum ModuleStage {
  SHALLOW = 0,
  DEEP = 1,
}

export enum ModuleStatus {
  DELETED = -1,
  ACTIVE = 0,
  PROCESSING = 1,
  ERROR_PROCESSING = 2,
  NEEDS_PUBLISHING = 3,
  TEMPLATE = 4,
}

export interface IModuleOut extends IBaseEntity {
  moduleId: number;
  sourceId: number;
  sourceHandle: number;
  targetId: number;
  targetHandle: number;
}

export interface IModuleVersion extends IBaseEntity {
  moduleId: number;
  parentModuleId: number;
  jsonUrl: string;
  name: string;
  groupId: number;
}

export interface IModuleVersionDAO extends IModuleVersion {
  group: IGroup;
}
